import * as _ from 'gleam:prelude'

export function baseURL() {
  try {
    return _.Result$Ok(import.meta.env.BASE_URL)
  } catch (_error) {
    return _.Result$Error()
  }
}

export function getEnv(name) {
  try {
    const vite = import.meta.env[`VITE_${name}`]
    const wxt = import.meta.env[`WXT_${name}`]
    const result = vite ?? wxt
    if (result === undefined) return _.Result$Error()
    return _.Result$Ok(result)
  } catch (_error) {
    return _.Result$Error()
  }
}
